import type * as core from '../../../../../../../core'

export const query: core.mosaic.Widget.Query = {
  quantity: 1,
  filter: {
    '=': [
      {
        '@.': '!id',
      },
      {
        '@$': 'subawardId',
      },
    ],
  },
  selection: {
    '{}': {
      name: 'Subaward Risk Assessment',
      type: 'questions',
      watch: {
        '[]': [
          {
            '{}': {
              alias: 'sr.actions.save-subaward-risk-assessment',
            },
          },
        ],
      },
      content: {
        '{}': {
          fields: {
            '[]': [
              {
                '{}': {
                  id: 'piDebarSuspend',
                  meta: {
                    '{}': {
                      dmsAttr: {
                        '{}': {
                          attributeId:
                            'attr:snap#!subawards#!subaward_risk_survey:!pi_debar_suspend',
                        },
                      },
                    },
                  },
                  value: {
                    '??': [
                      {
                        '@>': [
                          {
                            '@': 'previewRiskAssessment',
                          },
                          'piDebarSuspend',
                        ],
                      },
                      false,
                    ],
                  },
                  readonly: {
                    if: [
                      [
                        {
                          '=': [
                            {
                              '@$': 'isEdit',
                            },
                            true,
                          ],
                        },
                        false,
                      ],
                      true,
                    ],
                  },
                },
              },
              {
                '{}': {
                  id: 'pteAuditDecision',
                  meta: {
                    '{}': {
                      dmsAttr: {
                        '{}': {
                          attributeId:
                            'attr:snap#!subawards#!subaward_risk_survey:!pte_audit_decision',
                        },
                      },
                    },
                  },
                  value: {
                    '??': [
                      {
                        '@>': [
                          {
                            '@': 'previewRiskAssessment',
                          },
                          'pteAuditDecision',
                        ],
                      },
                      false,
                    ],
                  },
                  readonly: {
                    if: [
                      [
                        {
                          '=': [
                            {
                              '@$': 'isEdit',
                            },
                            true,
                          ],
                        },
                        false,
                      ],
                      true,
                    ],
                  },
                },
              },
              {
                '{}': {
                  id: 'itarEarConflict',
                  meta: {
                    '{}': {
                      dmsAttr: {
                        '{}': {
                          attributeId:
                            'attr:snap#!subawards#!subaward_risk_survey:!itar_ear_conflict',
                        },
                      },
                    },
                  },
                  value: {
                    '??': [
                      {
                        '@>': [
                          {
                            '@': 'previewRiskAssessment',
                          },
                          'itarEarConflict',
                        ],
                      },
                      false,
                    ],
                  },
                  readonly: {
                    if: [
                      [
                        {
                          '=': [
                            {
                              '@$': 'isEdit',
                            },
                            true,
                          ],
                        },
                        false,
                      ],
                      true,
                    ],
                  },
                },
              },
              {
                '{}': {
                  id: 'costShareIncluded',
                  meta: {
                    '{}': {
                      dmsAttr: {
                        '{}': {
                          attributeId:
                            'attr:snap#!subawards#!subaward_risk_survey:!cost_share_included',
                        },
                      },
                    },
                  },
                  value: {
                    '??': [
                      {
                        '@>': [
                          {
                            '@': 'previewRiskAssessment',
                          },
                          'costShareIncluded',
                        ],
                      },
                      false,
                    ],
                  },
                  readonly: {
                    if: [
                      [
                        {
                          '=': [
                            {
                              '@$': 'isEdit',
                            },
                            true,
                          ],
                        },
                        false,
                      ],
                      true,
                    ],
                  },
                },
              },
              {
                '{}': {
                  id: 'participantSupport',
                  meta: {
                    '{}': {
                      dmsAttr: {
                        '{}': {
                          attributeId:
                            'attr:snap#!subawards#!subaward_risk_survey:!participant_support',
                        },
                      },
                    },
                  },
                  value: {
                    '??': [
                      {
                        '@>': [
                          {
                            '@': 'previewRiskAssessment',
                          },
                          'participantSupport',
                        ],
                      },
                      false,
                    ],
                  },
                  readonly: {
                    if: [
                      [
                        {
                          '=': [
                            {
                              '@$': 'isEdit',
                            },
                            true,
                          ],
                        },
                        false,
                      ],
                      true,
                    ],
                  },
                },
              },
              {
                '{}': {
                  id: 'fedAwardExp',
                  meta: {
                    '{}': {
                      dmsAttr: {
                        '{}': {
                          attributeId:
                            'attr:snap#!subawards#!subaward_risk_survey:!fed_award_exp',
                        },
                      },
                    },
                  },
                  value: {
                    '??': [
                      {
                        '@>': [
                          {
                            '@': 'previewRiskAssessment',
                          },
                          'fedAwardExp',
                        ],
                      },
                      false,
                    ],
                  },
                  readonly: {
                    if: [
                      [
                        {
                          '=': [
                            {
                              '@$': 'isEdit',
                            },
                            true,
                          ],
                        },
                        false,
                      ],
                      true,
                    ],
                  },
                },
              },
              {
                '{}': {
                  id: 'otherRisksFound',
                  meta: {
                    '{}': {
                      dmsAttr: {
                        '{}': {
                          attributeId:
                            'attr:snap#!subawards#!subaward_risk_survey:!other_risks_found',
                        },
                      },
                    },
                  },
                  value: {
                    '??': [
                      {
                        '@>': [
                          {
                            '@': 'previewRiskAssessment',
                          },
                          'otherRisksFound',
                        ],
                      },
                      false,
                    ],
                  },
                  readonly: {
                    if: [
                      [
                        {
                          '=': [
                            {
                              '@$': 'isEdit',
                            },
                            true,
                          ],
                        },
                        false,
                      ],
                      true,
                    ],
                  },
                },
              },
              {
                '{}': {
                  id: 'primeSponsorType',
                  meta: {
                    '{}': {
                      dmsAttr: {
                        '{}': {
                          attributeId:
                            'attr:snap#!subawards#!subaward_risk_survey:!prime_sponsor_type',
                        },
                      },
                    },
                  },
                  value: {
                    '??': [
                      {
                        '@>': [
                          {
                            '@': 'previewRiskAssessment',
                          },
                          'primeSponsorType',
                        ],
                      },
                      '',
                    ],
                  },
                  readonly: {
                    if: [
                      [
                        {
                          '=': [
                            {
                              '@$': 'isEdit',
                            },
                            true,
                          ],
                        },
                        false,
                      ],
                      true,
                    ],
                  },
                },
              },
              {
                '{}': {
                  id: 'primeAwardType',
                  meta: {
                    '{}': {
                      dmsAttr: {
                        '{}': {
                          attributeId:
                            'attr:snap#!subawards#!subaward_risk_survey:!prime_award_type',
                        },
                      },
                    },
                  },
                  value: {
                    '??': [
                      {
                        '@>': [
                          {
                            '@': 'previewRiskAssessment',
                          },
                          'primeAwardType',
                        ],
                      },
                      '',
                    ],
                  },
                  readonly: {
                    if: [
                      [
                        {
                          '=': [
                            {
                              '@$': 'isEdit',
                            },
                            true,
                          ],
                        },
                        false,
                      ],
                      true,
                    ],
                  },
                },
              },
              {
                '{}': {
                  id: 'outFundsAmt',
                  meta: {
                    '{}': {
                      dmsAttr: {
                        '{}': {
                          attributeId:
                            'attr:snap#!subawards#!subaward_risk_survey:!out_funds_amt',
                        },
                      },
                    },
                  },
                  value: {
                    '??': [
                      {
                        '@>': [
                          {
                            '@': 'previewRiskAssessment',
                          },
                          'outFundsAmt',
                        ],
                      },
                      '',
                    ],
                  },
                  readonly: {
                    if: [
                      [
                        {
                          '=': [
                            {
                              '@$': 'isEdit',
                            },
                            true,
                          ],
                        },
                        false,
                      ],
                      true,
                    ],
                  },
                },
              },
              {
                '{}': {
                  id: 'subAwardPct',
                  meta: {
                    '{}': {
                      dmsAttr: {
                        '{}': {
                          attributeId:
                            'attr:snap#!subawards#!subaward_risk_survey:!sub_award_pct',
                        },
                      },
                    },
                  },
                  value: {
                    '??': [
                      {
                        '@>': [
                          {
                            '@': 'previewRiskAssessment',
                          },
                          'subAwardPct',
                        ],
                      },
                      '',
                    ],
                  },
                  readonly: {
                    if: [
                      [
                        {
                          '=': [
                            {
                              '@$': 'isEdit',
                            },
                            true,
                          ],
                        },
                        false,
                      ],
                      true,
                    ],
                  },
                },
              },
              {
                '{}': {
                  id: 'specialSubjects',
                  meta: {
                    '{}': {
                      dmsAttr: {
                        '{}': {
                          attributeId:
                            'attr:snap#!subawards#!subaward_risk_survey:!special_subjects',
                        },
                      },
                    },
                  },
                  value: {
                    '??': [
                      {
                        '@>': [
                          {
                            '@': 'previewRiskAssessment',
                          },
                          'specialSubjects',
                        ],
                      },
                      '',
                    ],
                  },
                  readonly: {
                    if: [
                      [
                        {
                          '=': [
                            {
                              '@$': 'isEdit',
                            },
                            true,
                          ],
                        },
                        false,
                      ],
                      true,
                    ],
                  },
                },
              },
              {
                '{}': {
                  id: 'subScopeWork',
                  meta: {
                    '{}': {
                      dmsAttr: {
                        '{}': {
                          attributeId:
                            'attr:snap#!subawards#!subaward_risk_survey:!sub_scope_work',
                        },
                      },
                    },
                  },
                  value: {
                    '??': [
                      {
                        '@>': [
                          {
                            '@': 'previewRiskAssessment',
                          },
                          'subScopeWork',
                        ],
                      },
                      '',
                    ],
                  },
                  readonly: {
                    if: [
                      [
                        {
                          '=': [
                            {
                              '@$': 'isEdit',
                            },
                            true,
                          ],
                        },
                        false,
                      ],
                      true,
                    ],
                  },
                },
              },
              {
                '{}': {
                  id: 'perfLocation',
                  meta: {
                    '{}': {
                      dmsAttr: {
                        '{}': {
                          attributeId:
                            'attr:snap#!subawards#!subaward_risk_survey:!perf_location',
                        },
                      },
                    },
                  },
                  value: {
                    '??': [
                      {
                        '@>': [
                          {
                            '@': 'previewRiskAssessment',
                          },
                          'perfLocation',
                        ],
                      },
                      '',
                    ],
                  },
                  readonly: {
                    if: [
                      [
                        {
                          '=': [
                            {
                              '@$': 'isEdit',
                            },
                            true,
                          ],
                        },
                        false,
                      ],
                      true,
                    ],
                  },
                },
              },
            ],
          },
          onSave: {
            if: [
              [
                {
                  '=': [
                    {
                      '??': [
                        {
                          '@$': 'isEdit',
                        },
                        false,
                      ],
                    },
                    false,
                  ],
                },
                null,
              ],
              {
                '{}': {
                  action: {
                    '{}': {
                      alias: 'sr.actions.save-subaward-risk-assessment',
                    },
                  },
                  variables: {
                    '{}': {
                      riskAssessmentId: {
                        '@>': [
                          {
                            '@': 'previewRiskAssessment',
                          },
                          'riskAssessmentId',
                        ],
                      },
                      perfLocation: '${field:perfLocation}',
                      subawardId: {
                        '@$': 'subawardId',
                      },
                      subScopeWork: '${field:subScopeWork}',
                      specialSubjects: '${field:specialSubjects}',
                      subAwardPct: '${field:subAwardPct}',
                      outFundsAmt: '${field:outFundsAmt}',
                      primeAwardType: '${field:primeAwardType}',
                      primeSponsorType: '${field:primeSponsorType}',
                      otherRisksFound: '${field:otherRisksFound}',
                      fedAwardExp: '${field:fedAwardExp}',
                      participantSupport: '${field:participantSupport}',
                      costShareIncluded: '${field:costShareIncluded}',
                      itarEarConflict: '${field:itarEarConflict}',
                      pteAuditDecision: '${field:pteAuditDecision}',
                      piDebarSuspend: '${field:piDebarSuspend}',
                    },
                  },
                },
              },
            ],
          },
        },
      },
      overflowActions: {
        if: [
          [
            {
              '=': [
                {
                  '??': [
                    {
                      '@$': 'isEdit',
                    },
                    false,
                  ],
                },
                true,
              ],
            },
            null,
          ],
          {
            '[]': [
              {
                '{}': {
                  icon: 'atn-icon atn-edit atn-blue',
                  name: 'Edit risk assessment',
                  action: {
                    '{}': {
                      payload: {
                        '{}': {
                          widget: {
                            '{}': {
                              alias:
                                'sr.subaward-details.widgets.risk-assessment',
                            },
                          },
                          variables: {
                            '{}': {
                              subawardId: {
                                '@$': 'subawardId',
                              },
                              isEdit: true,
                            },
                          },
                        },
                      },
                      operation: 'ui.modal',
                    },
                  },
                },
              },
            ],
          },
        ],
      },
    },
  },
  target: 'ent:!subawards:!subaward',
  subqueries: {
    previewRiskAssessment: {
      selection: {
        '{}': {
          riskAssessmentId: {
            '@.': '!id',
          },
          perfLocation: {
            '@.': '!perf_location',
          },
          subScopeWork: {
            '@.': '!sub_scope_work',
          },
          specialSubjects: {
            '@.': '!special_subjects',
          },
          subAwardPct: {
            '@.': '!sub_award_pct',
          },
          outFundsAmt: {
            '@.': '!out_funds_amt',
          },
          primeAwardType: {
            '@.': '!prime_award_type',
          },
          primeSponsorType: {
            '@.': '!prime_sponsor_type',
          },
          otherRisksFound: {
            '@.': '!other_risks_found',
          },
          fedAwardExp: {
            '@.': '!fed_award_exp',
          },
          participantSupport: {
            '@.': '!participant_support',
          },
          costShareIncluded: {
            '@.': '!cost_share_included',
          },
          itarEarConflict: {
            '@.': '!itar_ear_conflict',
          },
          pteAuditDecision: {
            '@.': '!pte_audit_decision',
          },
          piDebarSuspend: {
            '@.': '!pi_debar_suspend',
          },
        },
      },
      ref: {
        attr: 'attr:snap#!subawards#!subaward_risk_survey:!subj',
      },
      target: 'snap:!subawards:!subaward_risk_survey',
      quantity: 1,
    },
  },
}
